/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';
import NProgress from 'nprogress';
import { useRouter } from 'next/router';
export const useRouteProgress = () => {
  const router = useRouter();
  useEffect(() => {
    const handleRouteStart = () => NProgress.start();
    const handleRouteDone = () => NProgress.done();
    NProgress.configure({
      showSpinner: false
    });
    router.events.on('routeChangeStart', handleRouteStart);
    router.events.on('routeChangeComplete', handleRouteDone);
    router.events.on('routeChangeError', handleRouteDone);
    return () => {
      router.events.off('routeChangeStart', handleRouteStart);
      router.events.off('routeChangeComplete', handleRouteDone);
      router.events.off('routeChangeError', handleRouteDone);
    };
  }, [router]);
};